import routes from 'src/config/api.routes';
import axiosService from './axiosService';

class RolesService {
  GetRoles = async () => axiosService.get(routes.roles);
}

const rolesService = new RolesService();
export default rolesService;
